<template>
  <div class="location">
    <img src="@/assets/images/icons/star_red.svg" alt="" />
    <div class="location-main">
      当前位置：
      <span v-for="(item, index) in locationData" :key="item">
        <a
          @click="(event) => channelClick(event, item)"
          :class="{ active: index === locationData.length - 1 }"
        >
          {{ item }}
        </a>
        <span v-if="index < locationData.length - 1"> / </span>
      </span>
    </div>
  </div>
</template>

<script>
import { urls } from '@/utils'
export default {
  name: 'CommonLocation',
  props: {
    locationData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    channelClick(event, item) {
      event.preventDefault()
      console.log(item)
      for (let i in urls) {
        if (i === item) {
          window.open(urls[i])
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.location {
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  margin: 15px 0;
  padding: 0 15px;
  font-size: 0;
  img {
    width: 18px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .location-main {
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
    a {
      text-decoration: none;
      cursor: pointer;
    }
    .active {
      color: var(--theme-color);
    }
  }
}
</style>
